const BASE_URL: string = process.env.REACT_APP_PUBLIC_URL || ".";
const SHOW_PAGE: boolean = process.env.REACT_APP_SHOW_PAGE === "true" || false;
const ILO: string = process.env.REACT_APP_ILO || "./ilo/index.html";
const CSP: string = process.env.REACT_APP_CSP || "./csp/index.html";
const ENTERTAINMENT: string = process.env.REACT_APP_ENTERTAINMENT || "./entertainment/index.html";
const CONNECTIVITY: string = process.env.REACT_APP_CONNECTIVITY || "./connectivity/index.html";
const BMC: string = process.env.REACT_APP_BMC || "./bmc/index.html";
const AWS: string = process.env.REACT_APP_AWS || "./aws/index.html";

const Config = {
  BASE_URL,
  SHOW_PAGE,
  ILO,
  CSP,
  ENTERTAINMENT,
  CONNECTIVITY,
  BMC,
  AWS,
};

export default Config;
